import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { searchConstants } from '../../../search-utils/searchConstants';
import { SortTypes } from '../../../search.types';

type Props = {
  handleClick: Function;
  isSelected: boolean;
  type: SortTypes;
};

export function SortItem({ isSelected, handleClick, type }: Props) {
  return (
    <div
      className={classNames('search-filters-radio', {
        'filter__trigger--selected': isSelected,
      })}
      onClick={handleClick(type)}
    >
      <i
        className={classNames('material-icons search-filters-radio__icon', {
          icons__radio_button_unchecked: !isSelected,
          icons__radio_button_checked: isSelected,
          'search-filters-radio__icon--selected': isSelected,
        })}
      />
      <FormattedMessage id={searchConstants.sorts[type].labelId} />
    </div>
  );
}
